module.exports = __webpack_public_path__ + "static/bilingual-sourcing-febb41684a939ba6bd1211c2d1fe57cf.png";